import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../Components/theme";
import { CssBaseline} from '@mui/material';
import { ThemeProvider } from '@emotion/react';

export default function Header(props) {

    const classes ={
        header:{
            marginTop: ".5em",
            marginBottom: ".1em"
        }
    }
    return(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box textAlign='center'>
                <Typography variant="h4" style={classes.header} fontSize={{xl: 80, lg: 70, md: 70, sm: 70, xs: 40}}><Link className="Link" to={"/"}>ISS Daily Reports</Link></Typography>
                <Typography variant="h6" color={"primary"} fontSize={{xl: 40, lg: 30, md: 32, sm: 30, xs: 18}} m={1} fontWeight={800} >Powered by <a className="Link" href="https://thespacedevs.com/">TheSpaceDevs</a></Typography>    
            </Box>
        </ThemeProvider>
    )
}